import { ZoneFormData } from "@/formTypes/ZoneFormDataType";
import { ApiSchema } from "./ApiClient";
import { GenericModelApi } from "./GenericModelApi";

export type ZoneDataType = Partial<ApiSchema["Zone"]["type"] & ZoneFormData>;
export const ZoneApi = new GenericModelApi<"Zone", ZoneDataType>("Zone", "nombre");